import EmptyCell from 'components/table/components/EmptyCell';

// A line of a record's information: its label over its value, or a dash.
export const RecordField = ({ label, children }) => (
  <div className="border-b border-gray-100 py-2.5 last:border-0">
    <p className="text-xs text-gray-700">{label}</p>
    <div className="text-sm text-gray-900">{children || <EmptyCell />}</div>
  </div>
);

/**
 * The information of a record: `fields` are { label, value }, all of them. In
 * the record's side column (from the ls breakpoint, of fixed height), the list
 * takes the card's height and scrolls there.
 */
const RecordFields = ({ fields }) => (
  <div className="-mx-4 px-4 ls:min-h-0 ls:flex-1 ls:overflow-y-auto">
    {fields.map((field) => (
      <RecordField key={field.label} label={field.label}>
        {field.value}
      </RecordField>
    ))}
  </div>
);

export default RecordFields;
